module.exports = require('./helpers/bundle-url').getBundleURL('iPMsF') + "logo-dark.eefe0b7f.svg";